<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <h5 class="mb-0"><i class="fa fa-fw fa-archive mr-2" />Kirim Invent</h5>
            <hr />
            <b-row>
                <b-col md="4">
                    <b-form-group label="No. Faktur">
                        <b-form-input v-model="filter.no_faktur" maxlength="50" placeholder="Cari No. Faktur" @keydown.enter="getItems" />
                    </b-form-group>
                </b-col>
                <b-col md="4">
                    <b-form-group label="No. Request">
                        <b-form-input v-model="filter.noRequest" maxlength="50" placeholder="Cari No. Request" @keydown.enter="getItems" />
                    </b-form-group>
                </b-col>
                <b-col md="4">
                    <b-form-group label="Status">
                        <b-form-select v-model="filter.status" :options="optFilterStatus" />
                    </b-form-group>
                </b-col>
                <b-col md="4">
                    <b-form-group label="Kategori">
                        <multiselect v-model="filter.inventoryCategory" label="name" track-by="id" :internal-search="true"
                        deselect-label="" select-label="" :options="optInventoryCategoryFilter" />
                </b-form-group>
                </b-col>
                <b-col md="4">
                    <b-form-group label="Dikirim Ke">
                        <b-form-select v-model="filter.sent_to" :options="optSentTo" />
                    </b-form-group>
                </b-col>
                <b-col md="4">
                    <b-form-group label="Tgl. Kirim Inventaris Dari">
                        <b-form-input type="date" v-model="filter.startDate" @keydown.enter="getItems" />
                    </b-form-group>
                </b-col>
                <b-col md="4">
                    <b-form-group label="Tgl. Kirim Inventaris Sampai">
                        <b-form-input type="date" v-model="filter.endDate" @keydown.enter="getItems" />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="12" class="d-flex justify-content-end align-items-start mb-3">
                    <b-form-group label="Tambah" class="mb-0 mr-3" label-size="sm">
                        <b-button variant="success" @click="$bvModal.show('m-create')">
                            <i class="fa fa-plus mr-2" />Kirim Invent Baru
                        </b-button>
                    </b-form-group>
                    <b-form-group label="Aksi" class="mb-0 mr-2" label-size="sm">
                        <b-button variant="primary" @click="getItems()">
                            <i class="fa fa-search mr-2" />Cari
                        </b-button>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-table bordered hover show-empty no-local-sorting :busy="isBusy" :items="items" :fields="fields"
                @sort-changed="onSortChanged" responsive class="mb-3">
                <template v-slot:empty>
                    Tidak ada data Kirim Invent.
                </template>
                <template v-slot:cell(no_faktur)="row">
                    {{ row.item.no_faktur || "--DRAFT--" }}
                    <div class="small text-muted">
                        {{ row.item.no_ref || "-" }}<br />
                    </div>
                </template>
                <template v-slot:cell(sendback_request_number)="row">
                    {{ row.item.sendback_request_number || "-" }}
                </template>
                <template v-slot:cell(detail)="row">
                    Tanggal Faktur: {{ parseDate(row.item.send_date) }}
                    <div class="small text-muted">
                        Kategori: <strong>{{ row.item.inventory_category || "-" }}</strong>
                    </div>
                    <div class="small text-muted">
                        Draft: {{ row.item.created_by }} - {{ parseDate(row.item.created_at) }}
                    </div>
                    <div class="small text-muted" v-if="row.item.send_date">
                        Selesai: {{ row.item.confirmed_by }} - {{ parseDate(row.item.confirmed_at) }}
                    </div>
                </template>
                <template v-slot:cell(warehouse)="row">
                    <div class="small">
                        Asal: Gudang {{ row.item.warehouse }}<br>
                        Tujuan:
                        <b-badge v-if="row.item.sent_to === 'PGI'" variant="primary">PGI</b-badge>
                        <b-badge v-else-if="row.item.sent_to === 'PEI'" style="background-color: #C9963D; color: #fff;">PEI</b-badge>
                        <b-badge v-else-if="row.item.sent_to === 'Clickbait'" variant="danger">Clickbait</b-badge>
                        <b-badge v-else-if="row.item.sent_to === 'RBE'" variant="success">RBE</b-badge>
                        <span v-else>-</span>
                    </div>
                    <div class="small text-muted">
                        {{ row.item.item_count }} unit barang - {{ row.item.division }}
                    </div>
                </template>
                <template v-slot:cell(status)="row">
                    <b-badge :variant="getStatusBadge(row.item.status)[0]">{{ getStatusBadge(row.item.status)[1]
                        }}</b-badge>
                </template>
                <template v-slot:cell(action)="row">
                    <router-link v-if="row.item.status == 1" :to="'/kirim-inven/draft/' + row.item.id">
                        <b-button size="sm" variant="success" v-b-tooltip.hover.top title="Lanjut Draft">
                            <i class="fa fa-fw fa-pencil" />
                        </b-button>
                    </router-link>
                    <router-link v-if="[2, 3].includes(row.item.status)" :to="'/kirim-inven/list/' + row.item.id">
                        <b-button size="sm" variant="primary" v-b-tooltip.hover.top title="Detail Kirim Inven">
                            <i class="fa fa-fw fa-info" />
                        </b-button>
                    </router-link>
                </template>
            </b-table>
            <PageSizer :totalRows="totalRows" :page="currentPage" :options="options" @limit-change="onLimitChange"
                @page-change="onPageChange" />
        </b-card>
        <b-modal id="m-create" title="Kirim Invent Baru" centered no-close-on-backdrop hide-footer>
            <b-form-group label="Kirim inventaris dari gudang...">
                <multiselect v-model="input.warehouseFrom" label="name" track-by="id" :internal-search="true"
                    deselect-label="" select-label="" :options="optWarehouse" />
            </b-form-group>
            <b-form-group label="Divisi barang...">
                <multiselect v-model="input.division" label="name" track-by="id" :internal-search="true"
                    deselect-label="" select-label="" :options="optDivisions" />
            </b-form-group>
            <b-form-group label="Kategori Inventaris...">
                        <multiselect v-model="input.inventoryCategory" label="name" track-by="id" :internal-search="true"
                        deselect-label="" select-label="" :options="optInventoryCategory" />
                </b-form-group>
            <b-form-group label="Dikirim Ke">
                <b-form-select v-model="input.sent_to" :options="optSentToInput" />
            </b-form-group>
            <div class="mt-4 text-right">
                <b-button variant="primary" :disabled="isSubmitting" @click="createPindahGudang">
                    {{ isSubmitting ? "Membuat..." : "Kirim Invent Baru" }}
                </b-button>
            </div>
        </b-modal>
        <b-modal id="m-calculate" title="Perhitungan Totalan" no-close-on-backdrop no-close-on-esc hide-footer>
            <div v-if="isSubmitting">
                Mengambil data, mohon menunggu...
            </div>
            <div v-else>
                <div v-if="calculateTotalData.warehouseFrom != null && calculateTotalData.warehouseTo != null">
                    Asal: <strong>{{ calculateTotalData.warehouseFrom }}</strong><br />
                    Tujuan: <strong>{{ calculateTotalData.warehouseTo }}</strong>
                </div>
                <div v-if="calculateTotalData.start != null">
                    Dari Tanggal: <strong>{{ $helper.parseDate(calculateTotalData.start) }}</strong>
                </div>
                <div v-if="calculateTotalData.end != null">
                    Sampai Tanggal: <strong>{{ $helper.parseDate(calculateTotalData.end) }}</strong>
                </div>
                <hr />
                Total Faktur: <strong>{{ calculateTotalData.total_invoices }}</strong> invoice<br />
                Total Barang: <strong>{{ calculateTotalData.total_items }}</strong> barang
            </div>
        </b-modal>
    </div>
</template>

<script>

export default {
    data() {
        return {

            initStatus: 0,
            isBusy: true,
            isSubmitting: false,

            calculateTotalData: {},

            filter: {
                no_faktur: "",
                noRequest: "",
                status: -1,
                startDate: "",
                endDate: "",
                inventoryCategory: null,
                sent_to: ""
            },

            input: {
                warehouseFrom: null,
                division: null,
                inventoryCategory: null,
                sent_to: null
            },

            optSentTo: [
                { value: "", text: "Semua" },
                { value: "PGI", text: "PGI" },
                { value: "PEI", text: "PEI" },
                { value: "Clickbait", text: "Clickbait" },
                { value: "RBE", text: "RBE" }
            ],

            optSentToInput: [
                { value: null, text: "-- Pilih Tujuan --" },
                { value: "PGI", text: "PGI" },
                { value: "PEI", text: "PEI" },
                { value: "Clickbait", text: "Clickbait" },
                { value: "RBE", text: "RBE" }
            ],

            options: [
                { value: 10, text: '10' },
                { value: 20, text: '20' },
                { value: 30, text: '30' },
                { value: 40, text: '40' },
                { value: 50, text: '50' },
            ],

            fields: [
                { key: "no_faktur", label: "No. Faktur Kirim Invent", sortable: true },
                { key: "sendback_request_number", label: "No. Request", sortable: false },
                { key: "detail", label: "Detail Dokumen", sortable: false },
                { key: "warehouse", label: "Informasi Gudang", sortable: false },
                { key: "status", label: "Status", sortable: true },
                { key: "action", label: "Aksi" },
            ],

            items: [],
            currentPage: 1,
            perPage: 10,
            totalRows: 0,
            sortBy: null,
            sortDesc: false,

            optFilterStatus: [
                { value: -1, text: "Semua" },
                { value: 1, text: "Draft" },
                { value: 2, text: "Selesai" }
            ],

            optWarehouse: [],
            optDivisions: [],
            optFilterWarehouse: [],
            optInventoryCategory: [],
            optInventoryCategoryFilter: []

        }
    },

    methods: {

        init() {

            this.initStatus = 0
            let getItems = this.getItems()

            let getWarehouses = this.$axios.get("master/warehouse/selection").then(res => {
                this.optFilterWarehouse = [
                    { value: "", text: "Semua" }
                ]
                res.data.data.map(item => {
                    this.optFilterWarehouse.push({
                        value: item.id,
                        text: item.name + " - " + item.office_name
                    })
                    this.optWarehouse.push({
                        id: item.id,
                        name: item.name + " - " + item.office_name
                    })
                })
            })

            let getDivisions = this.$axios.get("division/get-all-filtered").then(res => {
                this.optDivisions = res.data.data
            })

            let getInventoryCategory = this.$axios.get("master/inventory-category").then(res => {
                this.optInventoryCategory = res.data.data.filter(item => item.id != 1) // filter except inventaris
            });

            let getInventoryCategoryFilter = this.$axios.get("master/inventory-category").then(res => {
                this.optInventoryCategoryFilter = res.data.data;
            });

            Promise.all([getItems, getWarehouses, getDivisions, getInventoryCategory, getInventoryCategoryFilter]).then(() => {
                this.initStatus = 1
            })
                .catch(error => {
                    this.initStatus = -1
                    error
                })

        },

        createPindahGudang() {

            if (this.input.warehouseFrom == null) {
                return this.$helper.toastError(this, "Mohon memilih gudang!")
            }

            if (this.input.division == null) {
                return this.$helper.toastError(this, "Mohon memilih divisi barang!")
            }

            if (this.input.inventoryCategory == null) {
                return this.$helper.toastError(this, "Mohon memilih kategori inventaris!");
            }

            if (!this.input.sent_to) {
                return this.$helper.toastError(this, "Mohon memilih tujuan kirim!")
            }

            this.isSubmitting = true
            let payload = {
                warehouse_id: this.input.warehouseFrom.id,
                division_id: this.input.division.id,
                inventory_category_id: this.input.inventoryCategory.id,
                sent_to: this.input.sent_to
            }

            this.$axios.post("inventory-pgi", payload).then(res => {
                let data = res.data.data
                this.$router.push({
                    name: "Draft Kirim Invent",
                    params: { id: data.sendback_id }
                })

            })
                .catch(error => this.$helper.parseError(this, error))
                .finally(() => this.isSubmitting = false)

        },

        getItems(page = 1) {

            this.isBusy = true
            this.items = []

            if (isNaN(page)) {
                this.currentPage = 1
            }
            else {
                this.currentPage = page
            }

            // URL builder
            let param = this.$helper.getBasePagedQuery(this.currentPage, this.perPage)

            if (!this.$helper.isBlank(this.filter.no_faktur)) {
                param += "&no_faktur=" + this.filter.no_faktur
            }

            if (!this.$helper.isBlank(this.filter.noRequest)) {
                param += "&sendback_request_number=" + this.filter.noRequest
            }

            if (this.filter.status != -1) {
                param += "&status=" + this.filter.status
            }

            if (this.filter.inventoryCategory != null) {
                param += "&inventory_category_id=" + this.filter.inventoryCategory.id
            }

            if (!this.$helper.isBlank(this.filter.startDate)) {
                param += "&start_date=" + this.filter.startDate
            }

            if (!this.$helper.isBlank(this.filter.endDate)) {
                param += "&end_date=" + this.filter.endDate
            }

            if (!this.$helper.isBlank(this.filter.sent_to)) {
                param += "&sent_to=" + this.filter.sent_to
            }

            if (this.sortBy != null) {
                param += "&sortBy=" + this.sortBy + "&sortDesc=" + this.sortDesc
            }

            return this.$axios.get("inventory-pgi" + param).then(res => {
                this.items = res.data.data.items
                this.totalRows = res.data.data.total
            })
                .catch(error => {
                    this.$helper.parseError(this, error)
                })
                .finally(() => {
                    this.isBusy = false
                })

        },

        onLimitChange(newPerPage) {
            this.perPage = newPerPage
            this.getItems(this.currentPage)
        },

        onPageChange(newPage) {
            this.currentPage = newPage
            this.getItems(this.currentPage)
        },

        onSortChanged(ctx) {
            this.sortBy = ctx.sortBy
            this.sortDesc = ctx.sortDesc
            this.getItems()
        },

        getStatusBadge(status) {
            switch (status) {
                case 1: return ["dark", "DRAFT"]
                case 2: return ["success", "SELESAI"]
                default: return ["light", "-"]
            }
        },

        parseDate(date) {
            if (!date) return "-";

            return `${this.$helper.parseDate(date)}, ${this.$helper.parseHourMinute(date)}` ;
        }

    },

    created() {
        this.init()
        this.$helper.toastFlash(this)
    }
}
</script>
